"use client";
import "./PackageTreatment.scss";
import AnimateHeight from "react-animate-height";
import { useState } from "react";

export default function PackageTreatment({ subheading, treatment, heading }) {
  const [height, setHeight] = useState(195);
  return (
    <div className="packageTreatmentWrapper">
      <p className="packageTreatmentHeading">
        {heading == null ? "Treatment" : heading}
      </p>
      {subheading != "" ? (
        <p className="packageTreatmentSubHeading">{subheading}</p>
      ) : null}

      <div className="treatmentInfo">
        <AnimateHeight
          style={{ width: "100%" }}
          id="example-panel"
          duration={500}
          height={height}
        >
          {treatment.map((item, i) => {
            return (
              <div className="treatmentPoints" key={i}>
                <p className="treatmentInfoData">{item}</p>
              </div>
            );
          })}
        </AnimateHeight>
      </div>

      <div className="showButtonContainer">
        {treatment.length > 3 ? (
          <button
            className="showMoreCostInIndiaBtn"
            aria-expanded={height !== 0}
            aria-controls="example-panel"
            onClick={() => setHeight(height == 195 ? "auto" : 195)}
          >
            {" "}
            {height === 195 ? "Show More +" : "View Less"}
          </button>
        ) : null}
      </div>
    </div>
  );
}
